<template>
  <div class="weichat-login">
    <div class="weichat-scan">
      <!-- <img src="../../public/icon/微信.png" alt="微信logo" /> -->
      <i
        class="iconfont icon-weixin1"
        style="font-size: 28px; margin-right: 8px; color: rgb(36, 219, 90)"
      ></i>
      <span>微信登录</span>
    </div>
    <p class="scan">使用微信扫一扫登录“<span class="sh">山河医学网</span>”</p>
    <div class="weiqr">
      <img src="../../../public/icon/黄倩-考试宝典.jpg" alt="" />
    </div>
    <div class="agree">
      <p>扫码既表示同意</p>
      <p>
        <a href="javascript:;">《隐私政策》</a>和<a href="javascript:;"
          >《山河医考用户注册协议》</a
        >
      </p>
    </div>
    <div class="change-login">
      <div class="left" @click="changeToPhone">
        <a href="javascript:;"
          ><i
            class="iconfont icon-shouji"
            style="font-size: 18px; margin-right: 5px"
          ></i
          >手机号登录</a
        >
      </div>
      <div class="right" @click="changeToPwd">
        <a href="javascript:;"
          ><i
            class="iconfont icon-denglu"
            style="font-size: 18px; margin-right: 5px"
          ></i
          >账号密码登录</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup(props, { emit }) {
    const changeToPwd = () => {
      emit("changePwd");
      
    };
    const changeToPhone = () => {
      
      emit("changeCode");
    };
    return { changeToPhone, changeToPwd };
  },
};
</script>

<style lang="less" scoped>
.weichat-login {
  align-items: center;
  //display: flex;
  //justify-content: center;
  .weichat-scan {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 25px;
      height: 25px;
      margin-right: 8px;
    }
    span {
      display: inline-block;
      font-size: 22px;
    }
  }

  .scan {
    text-align: center;
    margin-top: 25px;
    margin-bottom: 25px;
    .sh {
      color: red;
    }
  }
  .weiqr {
    display: flex;
    justify-content: center;

    img {
      width: 180px;
      height: 180px;
    }
  }
  .agree {
    margin-bottom: 15px;
    p {
      text-align: center;
      padding-top: 8px;
      a {
        color: @shColor;
      }
    }
  }
  .change-login {
    width: 388px;
    height: 78px;
    margin: 0 auto;
    //background: #e22828;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px dashed #dedede;

    .left {
      display: flex;
      justify-content: center;
      width: 186px;
      height: 18px;
      color: #666;
      border-right: 1px solid #dedede;
      font-size: 18px;
      & :hover {
        color: @shColor;
        cursor: pointer;
      }
    }
    .right {
      display: flex;
      justify-content: center;
      width: 187px;
      height: 18px;
      font-size: 18px;
      & :hover {
        color: @shColor;
        cursor: pointer;
      }
    }
  }
}
</style>
